import type { WorkflowStepReevaluationPayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';
import WorkflowPromptsView from '@UI/Store/OrganizationWorkflows/Views/WorkflowPromptsView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Re-evaluation settings of a document: whether it is enabled, and the prompts it runs with.
 */
class WorkflowReevaluationView {
	readonly enabled: boolean;
	readonly prompts: WorkflowPromptsView;

	constructor(payload: WorkflowStepReevaluationPayload) {
		this.enabled = payload.enabled;
		this.prompts = new WorkflowPromptsView(payload);

		Object.freeze(this);
	}
}

export default WorkflowReevaluationView;
